import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ReactiveFormsModule, UntypedFormControl } from '@angular/forms';
import { ButtonDirective, ButtonGroupComponent } from '@progress/kendo-angular-buttons';
import { CardModule } from '@progress/kendo-angular-layout';
import { ICellEditorAngularComp } from 'ag-grid-angular';
import { ICellEditorParams } from 'ag-grid-community';
import { Subject } from 'rxjs';
import { kendoIcons } from '../library/kendo-icons';

@Component({
  selector: "note-editor",
  template: `<kendo-card [width]="Width">
              <kendo-card-header class="k-hstack" style="padding-top: 5px;padding-bottom: 5px;padding-right: 5px;">
                <kendo-buttongroup style="float:right; padding:5px">
                    <button type="button" kendoButton themeColor="primary" style="margin-right: 5px;" color="primary" (click)="onClick('save')" [svgIcon]="icons.save"></button>
                    <button type="button" kendoButton themeColor="primary" color="primary" (click)="onClick('cancel')" [svgIcon]="icons.cancel"></button>
                </kendo-buttongroup>
              </kendo-card-header>
              <textarea style="height:80px" type="text" [maxlength]="maxLength" [formControl]="Note" class="form-control"></textarea>
            </kendo-card>`,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    CardModule,
    ButtonDirective,
    ButtonGroupComponent,
    ReactiveFormsModule,
  ],
})
export class PxdAgGridNoteEditorComponent implements ICellEditorAngularComp {

  public icons = kendoIcons;
  UnderlyingValue: any;
  Params: any;
  Note: UntypedFormControl;
  maxLength: number;
  Width: string;
  NoteEvent: Subject<any>;

  public agInit(params: any): void {
    this.Params = params;
    this.UnderlyingValue = params.UnderlyingValue;
    this.Note = new UntypedFormControl(params.Note);
    this.maxLength = params.MaxLength;
    this.Width = params.Width + 'px';
    this.NoteEvent = params.NoteEvent;
  }

  public getValue(): any {
    return this.UnderlyingValue;
  }

  public isPopup(): boolean {
    return true;
  }

  public getPopupPosition(): "over" | "under" {
    return "under";
  }

  onClick(action: string) {
    //call the NoteEvent.next with the save action to save the note. 
    this.NoteEvent.next({
      action: action,
      params: this.Params,
      note: this.Note.value
    });
  }
}

export interface INoteEditorComponentParams extends ICellEditorParams {
  Note?: string,
  UnderlyingValue?: string,
  MaxLength: number,
  Width: string,
  NoteEvent: Subject<any>
}